<form fsForm [submit]="submit" [dirtySubmitButton]="false" [confirm]="false">

  <app-logo></app-logo>

  <h2>
    Updated {{ header() }}
    <div class="subheading">Effective {{ effectiveDate() | fsDateFormat: 'full-date' }}</div>
  </h2>

  @if (message()) {
    <p>{{ message() }}</p>
  }
  <p>Please review and accept the updated terms to continue using the platform.</p>

  <app-terms-checkbox [type]="type()"></app-terms-checkbox>

  <app-stacked-buttons>
    <button type="submit" mat-flat-button color="primary">Continue</button>
    @if (skippable()) {
      <button type="button" mat-stroked-button (click)="skipForNow()">Skip for now</button>
    }
    <button type="button" mat-stroked-button (click)="cancel()">Cancel</button>
  </app-stacked-buttons>
</form>